import { PaginationRequest } from '../types';
import apiService from './api.service';

export enum SyntheticType {
  ACTIVE_USER = 'ACTIVE_USER',
  JOIN_FANCLUB = 'JOIN_FANCLUB',
  MATCH = 'MATCH',
  JOIN_MINI_GAME = 'JOIN_MINI_GAME',
  JOIN_20_FANCLUB = 'JOIN_20_FANCLUB',
}

export enum PeriodType {
  DAY = 'DAILY',
  WEEK = 'WEEKLY',
  MONTH = 'MONTHLY',
}
export type DashboardParamsType = {
  startAtFrom?: string;
  startAtTo?: string;
};

export type DashBoardExportStatisticParams = {
  fromDate: string;
  toDate: string;
};

export type DashBoardExportStatisticResponse = {
  blob: Blob;
  fileName: string;
  hasMore: boolean;
  totalFiles: number;
};

export type ChartDataType = {
  date: string;
  value?: number;
  blindBox?: number;
  quizGame?: number;
  predictionMatch?: number;
  fill?: string;
  logo?: string;
  name?: string;
};

export type DashboardRespItem = {
  syntheticDate: string;
  totalUserLogin: number;
  totalTurnOpenGift: number;
  totalTurnReceiveLuckyMoney: number;
  totalTurnFortuneTelling: number;
  totalTurnOpenGiftByCheckin: number;
  totalTurnOpenGiftByCheckin3Day: number;
  totalTurnOpenGiftByPackage: number;
  totalTurnOpenGiftByWatchVideo: number;
  totalUseOpenGift: number;
  totalUserCheckin: number;
  totalUserCheckin3Day: number;
};

export enum MiniGameType {
  BLIND_BOX = 'blindBox',
  QUIZ_GAME = 'quizGame',
  PREDICTION_MATCH = 'predictionMatch',
}
class DashboardService {
  async getData(params?: PaginationRequest & DashboardParamsType): Promise<DashboardRespItem[]> {
    const res = await apiService.get('/b/synthetic', { params });
    const data = res?.data?.data?.data || ([] as DashboardRespItem[]);
    return data || [];
  }

  async exportStatistics(params: DashBoardExportStatisticParams & PaginationRequest): Promise<DashBoardExportStatisticResponse> {
    const res = await apiService.get('/b/dashboard/export-statistic', { params, responseType: 'blob' });

    const total = res.headers['x-total-count'];

    const fileName = `${params.fromDate}_${params.toDate}_DanhSachLuotChoi${params.pageNo}.xlsx`;
    const hasMore = params.pageNo && params.pageSize ? params.pageNo * params.pageSize < total : false;
    const totalFiles = +(total / params.pageSize!).toFixed();

    return {
      blob: res.data,
      fileName,
      hasMore,
      totalFiles,
    };
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
